import React from "react"
import { PriceRangeFilter } from "../../../filters/PriceRangeFilter"

const FiltersModalPriceFilter = () => {
  return (
    <div className="pt-24 pb-4 pl-8 pr-8 overflow-x-hidden">
      <PriceRangeFilter />
    </div>
  )
}

export default FiltersModalPriceFilter
